import { useSubscription } from '@/hooks/useSubscription';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const SubscriptionBanner = () => {
  const { currentTier, tierLevel, tierLabel } = useSubscription();
  const navigate = useNavigate();

  const levelLabel = tierLevel === 0 ? "No Active Plan" : `${tierLabel} (Level ${tierLevel})`;

  return (
    <div className="w-full bg-gradient-to-r from-background via-background/95 to-background border-b border-border/40 py-3 px-4 flex items-center justify-between gap-4 flex-wrap z-50">
      <div>
        <div className="font-semibold text-sm text-foreground">Neil AI Customer Portal</div>
        <div className="text-xs text-muted-foreground">
          Current Access: <span className="text-primary font-semibold">{levelLabel}</span>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={() => navigate('/ai-automation')}
        className="text-xs"
      >
        Change / Upgrade Plan
      </Button>
    </div>
  );
};
